import React from 'react';
import { Form as AntFormV3 } from 'antd';
import { omit } from 'lodash';
import { FormUnloadWatcher, useUnloadHandler, UnloadProvider } from './ConfirmUnloadProvider';
import { FormProps } from 'antd/lib/form';
import { FormProvider, useForm } from './FormProvider';
import { defaultProps } from '@config/antd.config';
import Item from './Item';
import { FormItemLabel } from './FormItemLabel';
import { FormBlocker } from './FormBlocker';

export type TFormExtend = FormProps & {
  confirmOnUnload?: boolean
  children: React.ReactNode
}

export const Form = (props: TFormExtend) => {
  const confirmOnUnload = props.confirmOnUnload ?? defaultProps.form?.confirmOnUnload

  return (
    <AntFormV3 {...omit(props, 'confirmOnUnload')} hideRequiredMark={true} colon={false}>
      {confirmOnUnload && <FormUnloadWatcher />}
      {props.children}
    </AntFormV3>
  )
}

// Custom
Form.Item = Item
Form.useForm = useForm
Form.Blocker = FormBlocker
Form.Provider = FormProvider
Form.ItemLabel = FormItemLabel
Form.UnloadProvider = UnloadProvider
Form.useUnloadHandler = useUnloadHandler

// Orignal
Form.create = AntFormV3.create
Form.propTypes = AntFormV3.propTypes
Form.contextType = AntFormV3.contextType
Form.defaultProps = AntFormV3.defaultProps
Form.createField = AntFormV3.createFormField

